
$('body').on('click', '.top_tab_inner', function () {
  const attr = $(this).attr('tab-index');
  const classAdd = '.cstm__'+ attr;
  $('.top_tab_inner').removeClass('active_tab');
  $(this).addClass('active_tab');
  $('.bottom_tab_inner').removeClass('active_content');
  $(classAdd).addClass('active_content');
});

// home page banner section carousel

$('.place-holder-image').css('display', 'none');
if ($('.place-holder-image').css('display') === 'none') {
$('.home-banner-slider').owlCarousel({
  loop: true,
  autoplay: false,
  autoplayTimeout: 3000,
  smartSpeed: 300,
  autoplaySpeed: 300,
  autoplayHoverPause: true,
  slideTransition: 'ease-in-out',
  margin: 10,
  nav: true,
  dots: false,
  center: false,
  navText: [
    '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="18px" height="30px" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" xmlns:xlink="http://www.w3.org/1999/xlink"><g><path style="opacity:0.898" fill="#006836" d="M 12.5,-0.5 C 13.8333,-0.5 15.1667,-0.5 16.5,-0.5C 16.5,0.166667 16.8333,0.5 17.5,0.5C 17.5,9.83333 17.5,19.1667 17.5,28.5C 16.8333,28.5 16.5,28.8333 16.5,29.5C 15.1667,29.5 13.8333,29.5 12.5,29.5C 8.13858,24.8073 3.80525,20.1406 -0.5,15.5C -0.5,14.8333 -0.5,14.1667 -0.5,13.5C 3.80525,8.85942 8.13858,4.19275 12.5,-0.5 Z"/></g></svg>',
    '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="17px" height="30px" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" xmlns:xlink="http://www.w3.org/1999/xlink"><g><path style="opacity:0.969" fill="#006937" d="M -0.5,-0.5 C 1.16667,-0.5 2.83333,-0.5 4.5,-0.5C 8.52817,3.85934 12.5282,8.19268 16.5,12.5C 16.5,13.8333 16.5,15.1667 16.5,16.5C 12.5282,20.8073 8.52817,25.1407 4.5,29.5C 2.83333,29.5 1.16667,29.5 -0.5,29.5C -0.5,19.5 -0.5,9.5 -0.5,-0.5 Z"/></g></svg>',
  ],
  responsive: {
    0: {
      items: 1,
      nav: false,
      dots: true,
      margin: 6,
    },
    768: {
      items: 1,
      margin: 4,
    },
    1200: {
      items: 1,
    },
  },
});
};

// home page collection grid section carousel desktop
$('.owl-initial').removeClass('owl-initial');
$('.home-product-carousel').owlCarousel({
  loop: false,
  autoplay: false,
  autoplayTimeout: 3000,
  smartSpeed: 300,
  autoplaySpeed: 300,
  autoplayHoverPause: true,
  slideTransition: 'ease-in-out',
  margin: 10,
  nav: false,
  dots: true,
  center: false,
  navText: [
    '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="18px" height="30px" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" xmlns:xlink="http://www.w3.org/1999/xlink"><g><path style="opacity:0.898" fill="#006836" d="M 12.5,-0.5 C 13.8333,-0.5 15.1667,-0.5 16.5,-0.5C 16.5,0.166667 16.8333,0.5 17.5,0.5C 17.5,9.83333 17.5,19.1667 17.5,28.5C 16.8333,28.5 16.5,28.8333 16.5,29.5C 15.1667,29.5 13.8333,29.5 12.5,29.5C 8.13858,24.8073 3.80525,20.1406 -0.5,15.5C -0.5,14.8333 -0.5,14.1667 -0.5,13.5C 3.80525,8.85942 8.13858,4.19275 12.5,-0.5 Z"/></g></svg>',
    '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="17px" height="30px" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" xmlns:xlink="http://www.w3.org/1999/xlink"><g><path style="opacity:0.969" fill="#006937" d="M -0.5,-0.5 C 1.16667,-0.5 2.83333,-0.5 4.5,-0.5C 8.52817,3.85934 12.5282,8.19268 16.5,12.5C 16.5,13.8333 16.5,15.1667 16.5,16.5C 12.5282,20.8073 8.52817,25.1407 4.5,29.5C 2.83333,29.5 1.16667,29.5 -0.5,29.5C -0.5,19.5 -0.5,9.5 -0.5,-0.5 Z"/></g></svg>',
  ],
  responsive: {
    0: {
      items: 2,
      nav: false,
      dots: true,
      margin: 6,
    },
    768: {
      items: 4,
      margin: 4,
    },
    1200: {
      items: 4,
    },
  },
});

// home page collection grid section carousel mobile
$('#mobile-view').removeClass('initial-css');
$('.home-section--content').owlCarousel({
  loop: true,
  autoplay: false,
  autoplayTimeout: 3000,
  smartSpeed: 300,
  autoplaySpeed: 300,
  autoplayHoverPause: true,
  slideTransition: 'ease-in-out',
  margin: 10,
  nav: true,
  dots: false,
  center: false,
  navText: [
    '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="18px" height="30px" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" xmlns:xlink="http://www.w3.org/1999/xlink"><g><path style="opacity:0.898" fill="#006836" d="M 12.5,-0.5 C 13.8333,-0.5 15.1667,-0.5 16.5,-0.5C 16.5,0.166667 16.8333,0.5 17.5,0.5C 17.5,9.83333 17.5,19.1667 17.5,28.5C 16.8333,28.5 16.5,28.8333 16.5,29.5C 15.1667,29.5 13.8333,29.5 12.5,29.5C 8.13858,24.8073 3.80525,20.1406 -0.5,15.5C -0.5,14.8333 -0.5,14.1667 -0.5,13.5C 3.80525,8.85942 8.13858,4.19275 12.5,-0.5 Z"/></g></svg>',
    '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="17px" height="30px" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" xmlns:xlink="http://www.w3.org/1999/xlink"><g><path style="opacity:0.969" fill="#006937" d="M -0.5,-0.5 C 1.16667,-0.5 2.83333,-0.5 4.5,-0.5C 8.52817,3.85934 12.5282,8.19268 16.5,12.5C 16.5,13.8333 16.5,15.1667 16.5,16.5C 12.5282,20.8073 8.52817,25.1407 4.5,29.5C 2.83333,29.5 1.16667,29.5 -0.5,29.5C -0.5,19.5 -0.5,9.5 -0.5,-0.5 Z"/></g></svg>',
  ],
  responsive: {
    0: {
      items: 2,
      nav: false,
      dots: true,
      margin: 8,
    },
    768: {
      items: 4,
      margin: 4,
    },
    1200: {
      items: 4,
    },
  },
});

// spotlight section carousel
$('.spotlight-items-slider').owlCarousel({
  loop: true,
  autoplay: true,
  autoplayTimeout: 3000,
  smartSpeed: 300,
  autoplaySpeed: 300,
  autoplayHoverPause: true,
  slideTransition: 'ease-in-out',
  margin: 0,
  nav: true,
  dots: true,
  center: true,
  startPosition: 0,
  navText: [
    '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="18px" height="30px" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" xmlns:xlink="http://www.w3.org/1999/xlink"><g><path style="opacity:0.898" fill="#006836" d="M 12.5,-0.5 C 13.8333,-0.5 15.1667,-0.5 16.5,-0.5C 16.5,0.166667 16.8333,0.5 17.5,0.5C 17.5,9.83333 17.5,19.1667 17.5,28.5C 16.8333,28.5 16.5,28.8333 16.5,29.5C 15.1667,29.5 13.8333,29.5 12.5,29.5C 8.13858,24.8073 3.80525,20.1406 -0.5,15.5C -0.5,14.8333 -0.5,14.1667 -0.5,13.5C 3.80525,8.85942 8.13858,4.19275 12.5,-0.5 Z"/></g></svg>',
    '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="17px" height="30px" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" xmlns:xlink="http://www.w3.org/1999/xlink"><g><path style="opacity:0.969" fill="#006937" d="M -0.5,-0.5 C 1.16667,-0.5 2.83333,-0.5 4.5,-0.5C 8.52817,3.85934 12.5282,8.19268 16.5,12.5C 16.5,13.8333 16.5,15.1667 16.5,16.5C 12.5282,20.8073 8.52817,25.1407 4.5,29.5C 2.83333,29.5 1.16667,29.5 -0.5,29.5C -0.5,19.5 -0.5,9.5 -0.5,-0.5 Z"/></g></svg>',
  ],
  responsive: {
    0: {
      items: 1,
      autoWidth: false,
      nav: false,
    },
    768: {
      items: 1,
      autoWidth: false,
    },
  },
});

// about our product (tenet icons) section carousel
$('.content_image_container').owlCarousel({
  loop: true,
  smartSpeed: 300,
  slideTransition: 'ease-in-out',
  autoplay: true,
  autoplayTimeout: 3000,
  autoplaySpeed: 300,
  autoplayHoverPause: true,
  margin: 0,
  nav: true,
  dots: false,
  center: true,
  startPosition: 0,
  navText: [
    '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="18px" height="30px" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" xmlns:xlink="http://www.w3.org/1999/xlink"><g><path style="opacity:0.898" fill="#006836" d="M 12.5,-0.5 C 13.8333,-0.5 15.1667,-0.5 16.5,-0.5C 16.5,0.166667 16.8333,0.5 17.5,0.5C 17.5,9.83333 17.5,19.1667 17.5,28.5C 16.8333,28.5 16.5,28.8333 16.5,29.5C 15.1667,29.5 13.8333,29.5 12.5,29.5C 8.13858,24.8073 3.80525,20.1406 -0.5,15.5C -0.5,14.8333 -0.5,14.1667 -0.5,13.5C 3.80525,8.85942 8.13858,4.19275 12.5,-0.5 Z"/></g></svg>',
    '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="17px" height="30px" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" xmlns:xlink="http://www.w3.org/1999/xlink"><g><path style="opacity:0.969" fill="#006937" d="M -0.5,-0.5 C 1.16667,-0.5 2.83333,-0.5 4.5,-0.5C 8.52817,3.85934 12.5282,8.19268 16.5,12.5C 16.5,13.8333 16.5,15.1667 16.5,16.5C 12.5282,20.8073 8.52817,25.1407 4.5,29.5C 2.83333,29.5 1.16667,29.5 -0.5,29.5C -0.5,19.5 -0.5,9.5 -0.5,-0.5 Z"/></g></svg>',
  ],
  responsive: {
    0: {
      items: 1,
      nav: false,
      dots: true,
    },
    768: {
      items: 1,
    },
  },
});

// homepage Blog list  section carousel
$('.custom_blog_slider').owlCarousel({
  loop: true,
  autoplay: true,
  autoplayTimeout: 3000,
  smartSpeed: 300,
  autoplaySpeed: 300,
  autoplayHoverPause: true,
  slideTransition: 'ease-in-out',
  margin: 0,
  nav: true,
  dots: false,
  center: true,
  startPosition: 0,
  navText: [
    '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="18px" height="30px" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" xmlns:xlink="http://www.w3.org/1999/xlink"><g><path style="opacity:0.898" fill="#006836" d="M 12.5,-0.5 C 13.8333,-0.5 15.1667,-0.5 16.5,-0.5C 16.5,0.166667 16.8333,0.5 17.5,0.5C 17.5,9.83333 17.5,19.1667 17.5,28.5C 16.8333,28.5 16.5,28.8333 16.5,29.5C 15.1667,29.5 13.8333,29.5 12.5,29.5C 8.13858,24.8073 3.80525,20.1406 -0.5,15.5C -0.5,14.8333 -0.5,14.1667 -0.5,13.5C 3.80525,8.85942 8.13858,4.19275 12.5,-0.5 Z"/></g></svg>',
    '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="17px" height="30px" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" xmlns:xlink="http://www.w3.org/1999/xlink"><g><path style="opacity:0.969" fill="#006937" d="M -0.5,-0.5 C 1.16667,-0.5 2.83333,-0.5 4.5,-0.5C 8.52817,3.85934 12.5282,8.19268 16.5,12.5C 16.5,13.8333 16.5,15.1667 16.5,16.5C 12.5282,20.8073 8.52817,25.1407 4.5,29.5C 2.83333,29.5 1.16667,29.5 -0.5,29.5C -0.5,19.5 -0.5,9.5 -0.5,-0.5 Z"/></g></svg>',
  ],
  responsive: {
    0: {
      items: 1,
      nav: false,
    },
    768: {
      items: 3,
    },
  },
});

var $carousel = $('.custom_blog_slider');
var $dots = $carousel.find('.owl-dot'); 
if ($dots.length > 5) { 
  $dots.slice(5).hide();
}

// homepage Testimonial  section carousel
$('.simple_testimonial').owlCarousel({
  loop: true,
  autoplay: true,
  autoplayTimeout: 3000,
  smartSpeed: 300,
  autoplaySpeed: 300,
  autoplayHoverPause: true,
  slideTransition: 'ease-in-out',
  margin: 0,
  nav: true,
  dots: false,
  startPosition: 0,
  navText: [
    '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="30px" height="33px" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" xmlns:xlink="http://www.w3.org/1999/xlink"><g><path style="opacity:0.915" fill="#8cc119" d="M 12.5,-0.5 C 13.8333,-0.5 15.1667,-0.5 16.5,-0.5C 13.6553,5.18745 9.4886,9.85411 4,13.5C 3.83333,14.1667 3.66667,14.8333 3.5,15.5C 6.74507,20.2517 10.5784,24.585 15,28.5C 15.49,29.7932 15.6567,31.1266 15.5,32.5C 14.8333,32.5 14.1667,32.5 13.5,32.5C 9.22084,27.5542 4.55417,22.8875 -0.5,18.5C -0.5,16.5 -0.5,14.5 -0.5,12.5C 4.16667,8.5 8.5,4.16667 12.5,-0.5 Z"/></g><g><path style="opacity:0.949" fill="#8cc119" d="M 24.5,-0.5 C 25.5,-0.5 26.5,-0.5 27.5,-0.5C 27.8333,0.5 28.5,1.16667 29.5,1.5C 29.5,4.16667 29.5,6.83333 29.5,9.5C 28.8036,17.0671 28.1369,24.7338 27.5,32.5C 26.5,32.5 25.5,32.5 24.5,32.5C 20.2033,27.7021 15.7033,23.0355 11,18.5C 10.3333,16.8333 10.3333,15.1667 11,13.5C 15.7033,8.96455 20.2033,4.29788 24.5,-0.5 Z"/></g></svg>',
    '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="29px" height="33px" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" xmlns:xlink="http://www.w3.org/1999/xlink"><g><path style="opacity:0.988" fill="#8cc119" d="M -0.5,-0.5 C 1.16667,-0.5 2.83333,-0.5 4.5,-0.5C 8.12965,3.63104 11.963,7.63104 16,11.5C 18,14.1667 18,16.8333 16,19.5C 12.1667,23.3333 8.33333,27.1667 4.5,31C 2.86586,31.4935 1.19919,31.6602 -0.5,31.5C -0.5,20.8333 -0.5,10.1667 -0.5,-0.5 Z"/></g><g><path style="opacity:0.873" fill="#8cc119" d="M 12.5,-0.5 C 13.5,-0.5 14.5,-0.5 15.5,-0.5C 19.5,4.16667 23.8333,8.5 28.5,12.5C 28.5,14.5 28.5,16.5 28.5,18.5C 24.0355,22.4632 19.7022,26.6298 15.5,31C 14.0563,31.7805 12.723,31.6139 11.5,30.5C 16.2377,25.7685 20.571,20.7685 24.5,15.5C 20.7529,10.2469 16.4196,5.41352 11.5,1C 12.056,0.617425 12.3893,0.117425 12.5,-0.5 Z"/></g></svg>',
  ],
  responsive: {
    0: {
      items: 1,
      nav: false,
      dots: true,
    },
    768: {
      items: 2,
    },
  },
});

// product page recommendation section carousel
$('.product-section--content').owlCarousel({
  loop: false,
  margin: 10,
  nav: true,
  dots: false,
  center: false,
  navText: [
    '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="18px" height="30px" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" xmlns:xlink="http://www.w3.org/1999/xlink"><g><path style="opacity:0.898" fill="#006836" d="M 12.5,-0.5 C 13.8333,-0.5 15.1667,-0.5 16.5,-0.5C 16.5,0.166667 16.8333,0.5 17.5,0.5C 17.5,9.83333 17.5,19.1667 17.5,28.5C 16.8333,28.5 16.5,28.8333 16.5,29.5C 15.1667,29.5 13.8333,29.5 12.5,29.5C 8.13858,24.8073 3.80525,20.1406 -0.5,15.5C -0.5,14.8333 -0.5,14.1667 -0.5,13.5C 3.80525,8.85942 8.13858,4.19275 12.5,-0.5 Z"/></g></svg>',
    '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="17px" height="30px" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" xmlns:xlink="http://www.w3.org/1999/xlink"><g><path style="opacity:0.969" fill="#006937" d="M -0.5,-0.5 C 1.16667,-0.5 2.83333,-0.5 4.5,-0.5C 8.52817,3.85934 12.5282,8.19268 16.5,12.5C 16.5,13.8333 16.5,15.1667 16.5,16.5C 12.5282,20.8073 8.52817,25.1407 4.5,29.5C 2.83333,29.5 1.16667,29.5 -0.5,29.5C -0.5,19.5 -0.5,9.5 -0.5,-0.5 Z"/></g></svg>',
  ],
  responsive: {
    0: {
      items: 2,
      nav: false,
      dots: true,
      margin: 6,
      stagePadding: 15, 
    },
    768: {
      items: 4,
      margin: 4,
    },
    1200: {
      items: 4,
    },
  },
});

$('.super-saver-collection').owlCarousel({
  loop: false,
  autoplay: false,
  autoplayTimeout: 3000,
  smartSpeed: 300,
  autoplaySpeed: 300,
  autoplayHoverPause: true,
  slideTransition: 'ease-in-out',
  margin: 10,
  nav: false,
  dots: true,
  center: false,
  navText: [
    '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="18px" height="30px" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" xmlns:xlink="http://www.w3.org/1999/xlink"><g><path style="opacity:0.898" fill="#006836" d="M 12.5,-0.5 C 13.8333,-0.5 15.1667,-0.5 16.5,-0.5C 16.5,0.166667 16.8333,0.5 17.5,0.5C 17.5,9.83333 17.5,19.1667 17.5,28.5C 16.8333,28.5 16.5,28.8333 16.5,29.5C 15.1667,29.5 13.8333,29.5 12.5,29.5C 8.13858,24.8073 3.80525,20.1406 -0.5,15.5C -0.5,14.8333 -0.5,14.1667 -0.5,13.5C 3.80525,8.85942 8.13858,4.19275 12.5,-0.5 Z"/></g></svg>',
    '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="17px" height="30px" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" xmlns:xlink="http://www.w3.org/1999/xlink"><g><path style="opacity:0.969" fill="#006937" d="M -0.5,-0.5 C 1.16667,-0.5 2.83333,-0.5 4.5,-0.5C 8.52817,3.85934 12.5282,8.19268 16.5,12.5C 16.5,13.8333 16.5,15.1667 16.5,16.5C 12.5282,20.8073 8.52817,25.1407 4.5,29.5C 2.83333,29.5 1.16667,29.5 -0.5,29.5C -0.5,19.5 -0.5,9.5 -0.5,-0.5 Z"/></g></svg>',
  ],
  responsive: {
    0: {
      items: 2,
      nav: false,
      dots: true,
      margin: 6,
    },
    768: {
      items: 4,
      margin: 4,
    },
    1200: {
      items: 4,
    },
  },
});

class Header {
  constructor(options, settings) {
    this.$scripts = options.$scripts;
    this.section = options.section;
    this.header = this.section.querySelector('.site-header');
    this.searchBar = this.header.querySelector('[data-live-search]');
    this.postMessage = options.postMessage;
    this.settings = settings;
    this.stickyClass = 'site-header--sticky';

    if (this.settings.sticky_header) {
      console.log("Rafid",this.stickyClass);
      this.section.classList.add(this.stickyClass);
    }

    document.body.style.setProperty('--scrollbar-width', window.innerWidth - document.documentElement.clientWidth + "px"); // Setup search form/live search

    this.liveSearch = null;
    this.searchForm = null;

    if (this.settings.live_search.enable) {
      script_default()(this.$scripts.data('shopify-api-url'), () => {
        this.liveSearch = new LiveSearch({
          el: this.searchBar,
          header: this.header
        }, this.settings.live_search);
      });
    } else {
      this.searchForm = new SearchForm(this.searchBar);
    }
  }

  unload() {
    this.section.classList.remove(this.stickyClass);

    if (this.settings.live_search.enable) {
      this.liveSearch.unload();
    } else {
      this.searchForm.unload();
    }
  }

  onSectionBlockSelect() {// Do nothing
  }

  onSectionBlockDeselect() {// Do nothing
  }

  sectionDeselect() {// Do nothing
  }

}
